import { useIssuer } from "@/hooks/useIssuers";
import type { UseQueryResult } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import { Outlet, useParams } from "react-router";
import type { DTO } from "@equidefi/shared/types";

type IssuerContextType = UseQueryResult<DTO.Issuer, unknown>;

const IssuerContext = createContext<IssuerContextType>({} as IssuerContextType);

export default function IssuerContextProvider(): JSX.Element {
  const { id: issuerId } = useParams();
  const query: IssuerContextType = useIssuer(issuerId);

  return (
    <IssuerContext.Provider value={query}>
      <Outlet />
    </IssuerContext.Provider>
  );
}

export const useIssuerContext = () => {
  const { data: issuer, ...rest } = useContext(IssuerContext);
  return { issuer, ...rest };
};
